import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useDialogSessionOptional } from '@/features/DialogSession';
import { readFormInterval } from './recordForm';
import type { TranscriptRecordFormValues } from './types';

/**
 * Отдаёт шкале записи границы формы по мере ввода и снимает их, когда форма закрывается. Пока границы
 * не заданы целиком или начало позже конца, выделять нечего.
 *
 * `isEnabled` — выделяется отрезок именно этой формы: в паре реплик при выносе фрагмента шкала
 * показывает отрезок одной из них.
 */
export const useEditedIntervalSync = (isEnabled: boolean) => {
  const { control } = useFormContext<TranscriptRecordFormValues>();
  const [startedAt, finishedAt] = useWatch({ control, name: ['startedAt', 'finishedAt'] });
  const setEditedInterval = useDialogSessionOptional()?.setEditedInterval;

  useEffect(() => {
    if (!setEditedInterval || !isEnabled) return;
    setEditedInterval(readFormInterval(startedAt, finishedAt));
  }, [setEditedInterval, isEnabled, startedAt, finishedAt]);

  useEffect(() => {
    if (!setEditedInterval || !isEnabled) return;
    return () => setEditedInterval(null);
  }, [setEditedInterval, isEnabled]);
};
